import React, {createContext, useContext, useMemo, useState} from 'react';
import {renderRoutes} from 'react-router-config';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {useLocation} from 'react-router-dom';
import {AppSuspense} from '../../index';
import routes from '../../../modules';
import Scrollbar from '../Scrollbar';
import AppContext from '../../utility/AppContext';
import AppFooter from '../AppLayout/AppFooter';
import {RouteTransition} from '../../../shared/constants/AppEnums';
import AppErrorBoundary from '../AppErrorBoundary';
import AppContextPropsType from '../../../types/AppContextPropsType';
import { Box } from '@mui/material';
import { BoxProps } from '@mui/system';

interface TransitionWrapperProps {
  children: any;
}

const TransitionWrapper: React.FC<TransitionWrapperProps> = ({children}) => {
  const {rtAnim} = useContext<AppContextPropsType>(AppContext);
  const location = useLocation();
  if (rtAnim === RouteTransition.NONE) {
    return <>{children}</>;
  }
  return (
    <TransitionGroup appear enter exit>
      <CSSTransition
        key={location.key}
        timeout={{enter: 300, exit: 300}}
        classNames={rtAnim}>
        {children}
      </CSSTransition>
    </TransitionGroup>
  );
};

const ContentViewComponent = () => {
  const { additionalProps } = useMainContentView();

  return (
    <Scrollbar id={'scrollbar-app-container'}>
      <Box
        flexDirection='column'
        display='flex' flex={1}
        className='main-content-view'
        id='mainContentView'
        px='20px' pb='20px'
        {...additionalProps}
        // minHeight='100%'
        // pb={{xs: '20px', md: 4}}
      >
        <AppSuspense>
          <AppErrorBoundary>
            <TransitionWrapper>{renderRoutes(routes)}</TransitionWrapper>
          </AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
    </Scrollbar>
  );
};
// import React, {createContext, useContext, useState} from 'react';

interface MainContentViewContextProps {
  additionalProps: BoxProps;
  setAdditionalProps: React.Dispatch<React.SetStateAction<BoxProps>>;
}

const MainContentViewContext = createContext<MainContentViewContextProps>({
  additionalProps: {},
  setAdditionalProps: () => {},
});

export const useMainContentView = () => {
  const context = useContext(MainContentViewContext);
  if (!context) {
    throw new Error('useMainContentView must be used within a MainContentViewProvider');
  }
  return context;
};

const MainContentViewProvider: React.FC = ({ children }) => {
  const [style, setStyle] = useState<BoxProps>({});
  const contextValue = useMemo(
    () => ({ additionalProps: style, setAdditionalProps: setStyle }),
    [style],
  );

  return (
    <MainContentViewContext.Provider value={contextValue}>
      { children }
    </MainContentViewContext.Provider>
  );
};

const ContentView = () => (
  <MainContentViewProvider>
    <ContentViewComponent />
  </MainContentViewProvider>
);

export default ContentView;
